// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1qq7p","footer":"ModalError_footer__alpJ7"};